// extracted by mini-css-extract-plugin
export var arrows = "_2b-6";
export var decrementer = "_2b-a";
export var disabled = "_2b-4";
export var error = "_2b-1";
export var hiddenText = "_2b-b";
export var incrementer = "_2b-9";
export var input = "_2b-8";
export var inputWrapper = "_2b-0";
export var leadingIcon = "_2b-c";
export var readonly = "_2b-3";
export var regular = "_2b-7";
export var small = "_2b-5";
export var warning = "_2b-2";